import React from 'react';
import { BrowserRouter,Route, Switch} from 'react-router-dom';
import App from './login';
import Principal from './Principal';

export default class Router extends React.Component {
  constructor (props) {
      super(props);
      
      this.state = {
        estaLogueadostate: false,
      }
  }; //FIN CONSTRUCTOR


  render() {
      return (

        <BrowserRouter >
                <Switch>
                  <Route exact path="/login" component={App}   />
                  <Route exact path="/Principal" component={Principal}/> 
                  <Route exact path="/" component={App}   />     
                  <Route exact path="*" component={App}   />             
                </Switch>
        </BrowserRouter>
  
      );
  }
}
